import {
  GET_CREDITS,
  GET_CREDITS_SUCCESS,
  GET_CREDITS_ERROR,
  GET_CREDIT_MONTHS,
  GET_CREDIT_MONTHS_SUCCESS,
  GET_CREDIT_MONTHS_ERROR,
  ADD_SELECTED_CREDITS,
  REMOVE_SELECTED_CREDITS,
  SHOW_GLOBAL_SPINNER,
  HIDE_GLOBAL_SPINNER,
  GET_CLAIMED_CONTENT,
  GET_CLAIMED_CONTENT_SUCCESS,
  GET_CLAIMED_CONTENT_ERROR,
  SAVE_CREDITS,
  SAVE_CREDITS_SUCCESS,
  SAVE_CREDITS_ERROR,
  SET_PREPARED_CREDITS,
  REMOVE_PREPARED_CREDITS,
} from "../../constants/action-types";
import {
  combineCreditList,
  mergeCredits,
} from "../../helpers/availableCEUtils";
import { uniq } from "lodash";

export const availableCEInitialState = {
  creditList: [],
  isInitialDataFetching: false,
  isGlobalSpinnerShown: false,
  isCreditsSaving: false,
  fetchingCredits: {},
  selectedCredits: [],
  isFetchingClaimedUnits: false,
  preparedCredits: [],
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_CREDIT_MONTHS: {
      return {
        ...state,
        creditList: [],
        selectedCredits: [],
        preparedCredits: [],
        isInitialDataFetching: true,
      };
    }

    case GET_CREDIT_MONTHS_SUCCESS: {
      return {
        ...state,
        creditList: payload,
        isInitialDataFetching: false,
      };
    }

    case GET_CREDIT_MONTHS_ERROR: {
      return {
        ...state,
        isInitialDataFetching: false,
      };
    }

    case GET_CREDITS: {
      return {
        ...state,
        fetchingCredits: {
          ...state.fetchingCredits,
          [payload.creditListItemId]: true,
        },
      };
    }

    case GET_CREDITS_SUCCESS: {
      return {
        ...state,
        creditList: combineCreditList(
          state.creditList,
          payload.credits,
          payload.creditListItemId
        ),
        fetchingCredits: {
          ...state.fetchingCredits,
          [payload.creditListItemId]: false,
        },
      };
    }

    case GET_CREDITS_ERROR: {
      return {
        ...state,
        fetchingCredits: {
          ...state.fetchingCredits,
          [payload.creditListItemId]: false,
        },
      };
    }

    case SAVE_CREDITS: {
      return {
        ...state,
        isCreditsSaving: true,
      };
    }

    case SAVE_CREDITS_SUCCESS: {
      return {
        ...state,
        isCreditsSaving: false,
        creditList: mergeCredits(state.creditList, payload),
      };
    }

    case SAVE_CREDITS_ERROR: {
      return {
        ...state,
        isCreditsSaving: false,
      };
    }

    case ADD_SELECTED_CREDITS: {
      return {
        ...state,
        selectedCredits: uniq([...state.selectedCredits, ...payload]),
      };
    }

    case REMOVE_SELECTED_CREDITS: {
      return {
        ...state,
        selectedCredits: state.selectedCredits.filter(
          (item) => !payload.includes(item)
        ),
      };
    }

    case REMOVE_PREPARED_CREDITS: {
      return {
        ...state,
        preparedCredits: state.preparedCredits.filter(
          (item) => !payload.includes(item)
        ),
      };
    }

    case SHOW_GLOBAL_SPINNER: {
      return {
        ...state,
        isGlobalSpinnerShown: true,
      };
    }

    case HIDE_GLOBAL_SPINNER: {
      return {
        ...state,
        isGlobalSpinnerShown: false,
      };
    }

    case GET_CLAIMED_CONTENT: {
      return {
        ...state,
        isFetchingClaimedUnits: true,
      };
    }

    case GET_CLAIMED_CONTENT_ERROR:
    case GET_CLAIMED_CONTENT_SUCCESS: {
      return {
        ...state,
        isFetchingClaimedUnits: false,
      };
    }
    case SET_PREPARED_CREDITS: {
      return {
        ...state,
        preparedCredits: payload,
      };
    }

    default:
      return state;
  }
};
